<template>
  <div class="brand-intro">
      <img :src="info.bg" class="brand-bg">
      <div class="brand-info-box">
        <div class="brand-info">
            <img :src="info.logo" class="brand-logo">
            <div>{{ info.name }}</div>
        </div>
        <div class="brand-spec">
          <div class="brand-spec-content">{{ info.spec }}</div>
          <div class="brand-spec-more">全部</div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
<style lang="scss" scoped>
  .brand-intro {
    .brand-bg {
      width: 100%;
      height: 3.01rem;
    }
    .brand-info-box{
      transform: translateY(-1rem);
    }
    .brand-info{
      font-size: 0.28rem;
      text-align: center;
      font-weight: 800;
      .brand-logo{
        width: 1.15rem;
        height: 1.16rem;
        padding: 0.23rem;
        border-radius: 8px;
        background: #fff;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);
      }
    }
    .brand-spec{
      width: 7.02rem;
      font-size: 0.24rem;
      color: $cake-text-darkgrey;
      margin: 20px auto;
      overflow: hidden;
      max-height:0.97rem;
      position: relative;
      .brand-spec-content{
        line-height: 0.25rem;
      // display: -webkit-box;
      // -webkit-box-orient: vertical;
      // -webkit-line-clamp: 3;
      // overflow: hidden;
      // text-overflow: ellipsis;
      }
       .brand-spec-more {
        position: absolute;
        right: 0;
        bottom: 0;
        cursor: pointer;
        background-color: #fff;
        &:before {
            position: absolute;
            right: 100%;
            content: "";
            width:0.16rem;
            height:0.22rem;
            background-image: linear-gradient(270deg,#fff,hsla(0,0%,100%,0));
            }
        }
    }
  }
</style>
